export class AuthContext {
  constructor(
    readonly token: string,
    readonly refreshToken: string,
  ) {}
}
